import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Button, Dialog } from 'components';

export const DialogConfirmApprove = ({ open, onClose, onConfirm, isLoading, data }) => {
  const numeroOs = data?.os?.numeroOs;
  const operador = data?.laudo?.user;
  const operadorVinculado = Boolean(data?.tcomUser?.matched);

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs'>
      <Dialog.Title onClose={onClose}>Aprovar Laudo TCoM</Dialog.Title>
      <Dialog.Content>
        <Typography gutterBottom>
          Confirma a aprovação do laudo TCoM da OS <strong>{numeroOs}</strong>?
        </Typography>
        <Typography variant='body2' color='textSecondary' gutterBottom>
          {operadorVinculado ? (
            <>
              A aprovação será registrada no log do XPCell em nome do operador{' '}
              <strong>{operador}</strong>.
            </>
          ) : (
            <>
              O operador do arquivo (<strong>{operador || '-'}</strong>) não possui vínculo no
              XPCell — a aprovação será registrada em nome do usuário logado.
            </>
          )}
        </Typography>
        <Grid container spacing={2} style={{ marginTop: 8 }}>
          <Grid item xs={6}>
            <Button
              fullWidth
              color='secondary'
              variant='outlined'
              onClick={onClose}
              disabled={isLoading}
            >
              Não
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button fullWidth onClick={onConfirm} loading={isLoading}>
              Sim, aprovar
            </Button>
          </Grid>
        </Grid>
      </Dialog.Content>
    </Dialog>
  );
};
